const ALIAS_DOMAINS = [
  'start.firstadvantage.io',
  'start.firstadvantageresult.com',
  'myfirstadvantage.com',
  'apply.firstadvantage.io',
  'begin.firstadvantage.io',
  'go.farelief.com',
  'www.farelief.com',
  'farelief.com',
  'www.fadebtrelief.com',
  'fadebtrelief.com',
  'firstadvantagehq.com',
  'www.firstadvantagehq.com',
  'firstadvantagerelief.com',
  'www.firstadvantagerelief.com',
  'firstadvantagefreedom.com',
  'www.firstadvantagefreedom.com',
  'app.firstadvantage.io',
  'firstadvantagepro.com',
  'www.firstadvantagepro.com',
  'newleaffinancial.org',
  'freshstartadvantage.org',
  'horizondebtpartners.com',
  'brightpathrelief.com',
  'www.newleaffinancial.org',
  'www.freshstartadvantage.org',
  'www.horizondebtpartners.com',
  'www.brightpathrelief.com',
]

export function getComplianceLink(): string {
  const domain = window.location.host
  return ALIAS_DOMAINS.includes(domain) ? 'firstadvantage.io' : domain
}

export function getTcpaLanguageHtml(): string {
  const complianceLink = getComplianceLink()
  const privacy = `https://${complianceLink}/privacy-policy`
  const terms = `https://${complianceLink}/terms-of-use`

  return `By Clicking SEE RESULTS and submitting my form, I am providing my electronic signature in which I agree to the following: (a) the posted <a href="${privacy}" target="_blank" class="text-primary underline">Privacy Policy</a> and <a href="${terms}" target="_blank" class="text-primary underline">Terms of Use</a>, including the arbitration provision and waiver of participation in a class action litigation; and (b) I hereby provide my express written consent to share my information, including the mobile number with First Advantage Financial, JG Wentworth, Pacific Debt Relief, National Debt Relief, Clearone Advantage, Freedom Debt Relief, TurboDebt, Beyond Finance LLC dba Accredited Debt Relief, ARC Advantage, Upside Legal LLC, Resource Match and Rooted Realm calling or texting on their behalf who may contact me about their products and services which may be different than those on this website; and (c) I consent for each to contact me through automatic telephone dialing system, text, artificial or pre-recorded/artificial voice messages/A.I., including an autodialer via telephone, mobile device including SMS and MMS and/or email, even if my telephone number is listed on any state, federal or corporate Do Not Call registry. I understand that my consent is not required as a condition to purchase a good or service. I may opt out from SMS or Text messages at any time by replaying STOP. Data and SMS rates may apply. I may revoke this consent at any time.`
}

export function getTcpaLanguagePlain(): string {
  return getTcpaLanguageHtml().replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

export function getPrivacyPolicyUrl(): string {
  return 'https://firstadvantage.io/privacy-policy'
}

export function getTermsOfUseUrl(): string {
  return 'https://firstadvantage.io/terms-of-use'
}

export function getInfoPreferencesUrl(): string {
  return 'https://optconsumerprivacy.com/?site=fa'
}
